// ─── Status Enums ───────────────────────────────────────────────
export const GiftStatus = {
    OPEN: 'OPEN',
    CHOSEN: 'CHOSEN',
    DELETED: 'DELETED',
} as const;
export type GiftStatus = (typeof GiftStatus)[keyof typeof GiftStatus];

// ─── Background Themes ─────────────────────────────────────────
export const BackgroundType = {
    BIRTHDAY: 'BIRTHDAY',
    CHRISTMAS: 'CHRISTMAS',
    WEDDING: 'WEDDING',
    BABY_SHOWER: 'BABY_SHOWER',
    VALENTINES: 'VALENTINES',
    GRADUATION: 'GRADUATION',
    GENERAL: 'GENERAL',
} as const;
export type BackgroundType = (typeof BackgroundType)[keyof typeof BackgroundType];

// ─── Limits ─────────────────────────────────────────────────────
export const LIMITS = {
    MIN_ITEMS: 2,
    MAX_ITEMS: 20,
    MAX_TITLE_LENGTH: 120,
    MAX_DESCRIPTION_LENGTH: 500,
    MAX_IMAGE_SIZE_MB: 5,
    WIDGET_SESSION_TTL_HOURS: 24,
    PRESIGN_EXPIRY_SECONDS: 900,
} as const;

// ─── PostMessage Actions ────────────────────────────────────────
export const WidgetAction = {
    ADD_ITEM: 'PICKONEGIFT_ADD_ITEM',
    REMOVE_ITEM: 'PICKONEGIFT_REMOVE_ITEM',
    GET_ITEMS: 'PICKONEGIFT_GET_ITEMS',
    ITEMS_UPDATED: 'PICKONEGIFT_ITEMS_UPDATED',
    FINALIZE: 'PICKONEGIFT_FINALIZE',
    FINALIZED: 'PICKONEGIFT_FINALIZED',
    CLOSE: 'PICKONEGIFT_CLOSE',
    READY: 'PICKONEGIFT_READY',
} as const;
export type WidgetAction = (typeof WidgetAction)[keyof typeof WidgetAction];
